import { render, staticRenderFns } from "./NewsflashSettingsTab.vue?vue&type=template&id=21017124&scoped=true&"
import script from "./NewsflashSettingsTab.vue?vue&type=script&lang=js&"
export * from "./NewsflashSettingsTab.vue?vue&type=script&lang=js&"
import style0 from "./NewsflashSettingsTab.vue?vue&type=style&index=0&id=21017124&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21017124",
  null
  
)

export default component.exports